import React, { Fragment } from 'react';
import { func } from 'prop-types';
import { Query } from 'react-apollo';
import ErrorBoundary from 'components/ErrorBoundary';
import { GET_USER_RECIPE_BOX } from 'graphql/recipebox';

/**
 *
 * Get User Recipe Box query used for getting detailed info for each Recipe in the Box
 */
function GetUserRecipeBox(props) {
  const { children } = props;

  // Save errors on the client and catch on the server
  const errorPolicy = process.browser ? 'all' : 'none';

  return (
    <ErrorBoundary>
      <Query query={GET_USER_RECIPE_BOX} errorPolicy={errorPolicy} ssr={false}>
        {({
          data: queryData,
          loading: queryLoading,
          error: queryError,
          refetch: queryRefetch
        }) => (
          <Fragment>
            {children({
              data: queryData,
              error: queryError,
              loading: queryLoading,
              refetch: queryRefetch
            })}
          </Fragment>
        )}
      </Query>
    </ErrorBoundary>
  );
}

GetUserRecipeBox.propTypes = {
  children: func.isRequired
};

export default GetUserRecipeBox;
